class TextLinksSlider extends HTMLElement {
  constructor() {
    super()
    this.wrapper = this.querySelector('.Text-Links-Slider__Wrapper')
    this.items = this.wrapper.querySelectorAll('.Text-Links-Slider__Single')
    this.background = this.querySelector('.Text-Links-Slider')
    this.updateImages = Boolean(this.dataset.updateImages)
    
    this.handleScroll = this.handleScroll.bind(this)
    // this.handleClick = this.handleClick.bind(this)
    this.handleHover = this.handleHover.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.updateHeight = this.updateHeight.bind(this)
    this.currentBackgroundImage = undefined
    this.defineDefaultImage.bind(this)
  }

  connectedCallback() {
    this.wrapper.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.updateHeight)
    this.items.forEach(item => {
      item.addEventListener('mouseenter', this.handleHover)
      item.addEventListener('mouseleave', this.handleMouseLeave)
      
      // item.querySelectorAll('[js-mobile-focus]').forEach(anchor => {
      //   anchor.addEventListener('click', this.handleClick)
      // })
    })
    
    this.updateHeight()
    this.handleScroll()
  }

  disconnectedCallback() {
    this.wrapper.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.updateHeight)
    this.items.forEach(item => {
      item.removeEventListener('mouseenter', this.handleHover)
      item.removeEventListener('mouseleave', this.handleMouseLeave)
      
      // item.querySelectorAll('[js-mobile-focus]').forEach(anchor => {
      //   anchor.removeEventListener('click', this.handleClick)
      // })
    })
  }

  defineDefaultImage() {
    if (window.innerWidth >= 768) {
      this.defaultImage = this.dataset.defaultImage
    } else {
      this.defaultImage = this.dataset.defaultMobileImage
    }
    if (this.currentBackgroundImage === undefined) {
      this.currentBackgroundImage = this.defaultImage
    }
  }

  updateHeight() {
    const parentHeight = this.getBoundingClientRect().height
    this.style.setProperty('--Section-Height', `${parentHeight}px`)
    this.wrapper.style.height = `${parentHeight}px`
    this.defineDefaultImage()
  }

  handleScroll() {
    if (window.innerWidth >= 768) return
    
    let closestElement = null
    let closestDistance = Infinity
    const wrapperRect = this.wrapper.getBoundingClientRect()
    const centerX = wrapperRect.left + wrapperRect.width / 2
    
    this.items.forEach(item => {
      const itemRect = item.getBoundingClientRect()
      const itemCenterX = itemRect.left + itemRect.width / 2
      const distance = Math.abs(centerX - itemCenterX)
      
      if (distance < closestDistance) {
        closestDistance = distance
        closestElement = item
      }
    })
    
    if (closestElement) {
      this.items.forEach(item => item.classList.remove('is-active'))
      closestElement.classList.add('is-active')
      this.updateBackground(closestElement)
    }
  }

  // handleClick(event) {
  //   if (window.innerWidth >= 768) return

  //   const parentItem = event.currentTarget.classList.contains('Text-Links-Slider__Single')
  //     ? event.currentTarget 
  //     : event.currentTarget.closest('.Text-Links-Slider__Single')

  //   if (!parentItem.classList.contains('is-active')) {
  //     event.preventDefault()
  //     this.scrollToElement(parentItem)
  //   }
  // }

  scrollToElement(element) {
    const wrapperRect = this.wrapper.getBoundingClientRect()
    const elementRect = element.getBoundingClientRect()
    const scrollLeft = this.wrapper.scrollLeft + (elementRect.left - wrapperRect.left - wrapperRect.width / 2 + elementRect.width / 2)
    
    this.wrapper.scrollTo({ left: scrollLeft, behavior: 'smooth' })
    
    setTimeout(() => {
      this.items.forEach(item => item.classList.remove('is-active'))
      element.classList.add('is-active')
      this.updateBackground(element)
    }, 300)
  }

  handleHover(event) {
    if (window.innerWidth < 768) return
    
    this.items.forEach(item => item.classList.remove('is-active'))
    event.currentTarget.classList.add('is-active')
    this.updateBackground(event.currentTarget)
  }

  handleMouseLeave(event) {
    if (window.innerWidth < 768) return
    
    event.currentTarget.classList.add('is-active')
  }

  updateBackground(activeItem) {
    console.log(' this.updateImages:', this.updateImages)
    if (!this.updateImages) {
      return
    }
    let imageUrl = activeItem.dataset.mobileImage
    if (window.innerWidth >= 768) {
      imageUrl = activeItem.dataset.image
    }

    if (imageUrl === this.currentBackgroundImage) {
      return
    }
    if (imageUrl) {
      this.background.style.backgroundImage = `url(${imageUrl})`
      this.background.style.opacity = '1'
      this.currentBackgroundImage = imageUrl
    } else if (this.defaultImage) {
      this.background.style.backgroundImage = `url(${this.defaultImage})`
      this.background.style.opacity = '1'
      this.currentBackgroundImage = this.defaultImage
    } else {
      this.background.style.backgroundImage = ''
      this.background.style.opacity = '0'
      this.currentBackgroundImage = ''
    }
  }
}

customElements.define('text-links-slider', TextLinksSlider)
